module.exports = __webpack_public_path__ + "media/img/pages/companies/collini-32a47ea015b86c972f7b35669db2e18b.png";